export const noop = (): null => null;

export const skaCountryConfig = {
  'notino.cz': {
    locale: 'cz',
    partnerId: 'WrLfKJfKTV',
  },
  'notino.sk': {
    locale: 'sk',
    partnerId: 'NZoKUT127u',
  },
  'notino.it': {
    locale: 'it',
    partnerId: 'tC4ZmDdLCc',
  },
  'notino.pl': {
    locale: 'pl',
    partnerId: 'Vl04MGlEhq',
  },
  'notino.ro': {
    locale: 'ro',
    partnerId: 'LTFRAa90DW',
  },
  'notino.hu': {
    locale: 'hu',
    partnerId: 'L51VtFIbsA',
  },
  'notino.hr': {
    locale: 'hr',
    partnerId: 'Ul9Gm7PfaZ',
  },
  'notino.ch': {
    locale: 'ch',
    partnerId: 'L8Q6in5Ap9',
  },
  'notino.bg': {
    locale: 'bg',
    partnerId: 'qhiCGDsbZo',
  },
  'notino.ua': {
    locale: 'ua',
    partnerId: 'iAAIy0Yvpf',
  },
};
